import { serviceRequest } from 'utils/http';
import {
  ExternalReferralService,
  ExternalReferralStatusChangeDto,
} from 'common/api';
import { ReferralStatusType } from 'global/referralStatus';

type UpdateExternalReferralStatus = {
  id: string;
  status: ReferralStatusType;
  appointmentDate?: string;
  consentedDate?: string;
  isVisited?: boolean;
};

export function updateExternalReferralStatusAPI({
  id,
  status,
  appointmentDate,
  consentedDate,
  isVisited,
}: UpdateExternalReferralStatus) {
  return serviceRequest(() =>
    ExternalReferralService.externalReferralControllerChangeStatus(id, {
      referralStatus:
        status as unknown as ExternalReferralStatusChangeDto.referralStatus,
      appointmentDateTime: appointmentDate,
      consentedDate,
      isVisited,
    })
  );
}
